import React, { useState } from "react";
import { BCAddVerbruikRequest } from "../../../Interfaces/BCAddVerbruikRequest";
import { BCItem } from "../../../Interfaces/BCItem";
import { Service } from "../../../Interfaces/Service";
import { DataService } from "../../../Services/DataService";
import { Divider, Form, Input, InputNumber, Modal, Select } from "antd";
import { BCNewOrderLine, BCNewOrderRequest } from "../../../Interfaces/BCNewOrderRequest";
import { BCServiceItem } from "../../../Interfaces/BCServiceItem";

type Props = {
    onOk: (line: BCNewOrderLine) => void;
    onCancel: () => void;
    isOpen: boolean;
    request: BCNewOrderRequest;
}

const AddServiceItemModal = (props: Props) => {

    const [form] = Form.useForm();

    const [serviceItems, setServiceItems] = useState<Service<BCServiceItem[]>>({ status: "loading" });
    const [items, setItems] = useState<Service<BCItem[]>>({ status: "loading" });
    const [disableForm, setDisableForm] = useState(false);


    React.useEffect(() => {
        DataService.getServiceItems(props.request.customerNo, props.request.addressCode ? props.request.addressCode : "").then(res => {
            setServiceItems(res);
        }).catch(err => {
            setServiceItems({ status: "error", error: err })
        });
        DataService.getItems().then(res => {
            setItems(res);
        }).catch(err => {
            setItems({ status: "error", error: err })
        });
    }, []);

    return (
        <Modal
            //className="astena-modal"
            open={props.isOpen}
            title={"Service artikel toevoegen"}
            okText="Toevoegen"
            cancelText="Annuleren"
            onCancel={props.onCancel}

            onOk={() => {
                form
                    .validateFields()
                    .then((values) => {
                        props.onOk({
                            description: values.description,
                            serialNo: values.serialNo ? values.serialNo : "",
                            serviceItemNo: values.serviceItemNo,
                            itemNo: values.itemNo ? values.itemNo : "",
                        })
                        form.resetFields();

                    })
                    .catch((info) => {
                        //console.log('Validate Failed:', info);
                    });
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name="form_in_modal"
                style={{ padding: 20 }}
            >
                <Form.Item
                    name="serviceItemNo"
                    label="Service artikel"
                //rules={[{ required: true, message: 'Artikel verplicht' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        onChange={(val) => {
                            if (val && val != "") {
                                setDisableForm(true);
                            } else {
                                setDisableForm(false);
                            }
                            if (serviceItems.status === "loaded") {
                                let serItem = serviceItems.payload.find(x => x.no == val);
                                if (serItem) {
                                    form.setFieldValue("itemNo", serItem.itemNo);
                                    form.setFieldValue("description", serItem.description);
                                    form.setFieldValue("serialNo", serItem.serialNo)
                                }
                            }

                        }}
                        filterOption={(inputValue, option) =>
                            option!.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                        options={serviceItems.status === "loaded" ? serviceItems.payload.map(x => {
                            return {
                                label: x.description + ` (${x.no})`,
                                value: x.no
                            }
                        }) : []} placeholder="Kies service artikel" />

                </Form.Item>
                <Divider />
                <Form.Item
                    name="itemNo"
                    label="Artikel"
                    //rules={[{ required: true, message: 'Artikel verplicht' }]}

                >
                    <Select
                        disabled={disableForm}
                        showSearch
                        onChange={(val) => {
                            if (items.status === "loaded") {
                                let desc = items.payload.find(x => x.no == val);
                                if (desc)
                                    form.setFieldValue("description", desc.description)
                            }

                        }}
                        filterOption={(inputValue, option) =>
                            option!.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                        options={items.status === "loaded" ? items.payload.map(x => {
                            return {
                                label: x.description + ` (${x.no})`,
                                value: x.no
                            }
                        }) : []} placeholder="Kies artikel" />

                </Form.Item>
                <Form.Item
                    name="description"
                    label="Omschrijving"
                    rules={[{ required: true, message: 'Omschrijving verplicht' }]}
                >
                    <Input disabled={disableForm} />
                </Form.Item>
                <Form.Item
                    name="serialNo"
                    label="Serienummer"
                //rules={[{ required: true, message: 'Serienummer verplicht' }]}
                >
                    <Input maxLength={50} disabled={disableForm} />
                </Form.Item>
            </Form>
        </Modal>

    );
};

export default AddServiceItemModal;